import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

const MenuUpDown  = props => {
    const {
        visible,
        updownClick
    } = props;

    return (visible && (

        <div className="btn-area-updown">
            <button className="updown-btn ico btn-com-chevron-up" onClick={() => updownClick('up')}>up</button>
            <button className="updown-btn ico btn-com-chevron-down" onClick={() => updownClick('down')}>down</button>
        </div>

        )
    );
};

export default MenuUpDown;